/**
 * Object that can be used to set conditional
 * class names
 */
interface IClassNameObject {
	[ cname: string ]: boolean;
}

/**
 * Mixed type for class names
 *
 * Samples:
 *   - "hello"
 *   - ["hello", "world"]
 *   - { "hello": true }
 *   - ["hello", { world: true }]
 *   - ["hello", { [`abc-${var}`]: showAbc === true }, "world"]
 */
export type TClassName = string | Array<string | IClassNameObject | any> | IClassNameObject;

/**
 * Function to convert a TClassName to a string. Pass the default class name
 * to append at the end
 *
 * @param cname
 * @param className
 */
export function classNames(cname?: TClassName, className?: string): string | undefined {
	if (!cname) {
		return className || undefined;
	}
	if (typeof cname === "string") {
		return (cname + " " + (className || "")).trim();
	}
	if (Array.isArray(cname)) {
		const classes: string[] = [];
		for (const obj of cname) {
			const cls = classNames(obj);
			if (cls) {
				classes.push(cls);
			}
		}
		if (className) {
			classes.push(className);
		}
		return classes.length > 0 ? classes.join(" "): undefined;
	}
	// Objects
	const classes: string[] = [];
	for (const key in cname) {
		if (cname[key]) {
			classes.push(key);
		}
	}
	if (className) {
		classes.push(className);
	}
	return classes.length > 0 ? classes.join(" "): undefined;
}
